function SpeechBubble({ header, subtitle }) {
    return (
        <div className="relative shadow-lg bg-white border-2 border-primary rounded-3xl p-4 m-4 max-w-md">
            {/* Triangle pointer */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-0 h-0 
                          border-l-[16px] border-l-transparent
                          border-r-[16px] border-r-transparent
                          border-b-[16px] border-b-primary">
            </div>

            <h1 className="font-bold text-center">{header}</h1>
            <div className="mt-2">
                {subtitle}
            </div>
        </div>
    );
}

export default SpeechBubble;